import React from 'react'
import ReactDOM from 'react-dom'
import 'tachyons'

import App from './App'
import './App.css'

import { ThemeStore } from './stores/ThemeStore'
document.body.className = 'theme-' + ThemeStore.name()

ReactDOM.render(
	<App />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js